import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import Heading from "../ui/Heading";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { ImageUrl, Je_welryspelling } from "../../../../../Helpers/request";
import design1 from '../../../../../Assets/images/custom-design1.png'
import design2 from '../../../../../Assets/images/custom-design2.png'
import webuy1 from '../../../../../Assets/images/we-buy1.png'
import webuy2 from '../../../../../Assets/images/we-buy2.png'
import dividerLine from '../../../../../Assets/images/divider-line.png'


const CustomDesign = () => {
  return (
    <>
 
  
    <section className="custom-design section-space">
      
      <Container fluid>
        <Row className="align-items-center">
          <Col md={4} xs={12} className="text-center">
            <Image src={webuy1} alt="Custom Design Jewelry " className="w-100 m-auto  h-auto" />
          </Col>

          <Col md={4} xs={12}>
            <Heading>
              {/* <span >Be the Designer</span> */}
              <h2 className="text-capitalize">We Buy</h2>
             
<p>At Dynasty Jewelers, we believe that turning designer {Je_welryspelling} into quick cash without
actually selling your precious treasures is ideal. Whether it be a wedding ring or a {Je_welryspelling}
set inherited from your grandmother, each one of them holds a special place in your heart,
therefore, bidding goodbye to them can be heartbreaking. Dynasty has come up with
an ideal solution where you can receive quick cash yet still remain the proud
owner of the fine piece of {Je_welryspelling}.</p>
            </Heading>

            <div className="text-center">
              <Link to="/webuy" className="btn outline-base-btn large ">  
               Read More
              </Link>
            </div>
          </Col>
          <Col md={4} xs={12} className="text-center p-lg-0 p-md-0 ">
            <Image src={webuy2} alt="Custom Design Jewelry " className="w-100 h-auto m-auto" />
          </Col>
        </Row>
      </Container>
      <Container className="mt-5 mb-5">
  <Image src={dividerLine} className="img-fluid w-100 m-auto"/>
      </Container>
        <Container fluid>
        <Row className="align-items-center">
          <Col md={4} xs={12} className="text-center">
            <Image src={design1} alt="Custom Design Jewelry " className="w-100 m-auto  h-auto" />
          </Col>

          <Col md={4} xs={12}>
            <Heading>
              {/* <span className="text-uppercase">Be the Designer</span> */}
              <h2 className="text-capitalize" >Custom <br></br> Design {Je_welryspelling} </h2>
              <p>Custom {Je_welryspelling} is a testament to personal
style and individuality, where dreams are
transformed into wearable art.</p>
            </Heading>

            <div className="text-center">
              <Link to="/custom-design" className="btn outline-base-btn large ">  
                Get Started
              </Link>
            </div>
          </Col>
          <Col md={4} xs={12} className="text-center p-lg-0 p-md-0 ">
            <Image src={design2} alt="Custom Design Jewelry " className="w-100 h-auto m-auto" />
          </Col>

        </Row>
      </Container>
    </section>
       </>
  );
};

export default CustomDesign;
